import { render, staticRenderFns } from "./calendarcomponents.vue?vue&type=template&id=57e63945&scoped=true"
import script from "./calendarcomponents.vue?vue&type=script&lang=js"
export * from "./calendarcomponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e63945",
  null
  
)

export default component.exports